// @flow

import { observable, action, runInAction, configure } from 'mobx';
import jobsApi from 'api/jobs.api';
import workTypesApi from 'api/workTypes.api';
import studiesApi from 'api/studies.api';
import categoriesApi from 'api/categories.api';
import industriesApi from 'api/industries.api';
import regionsApi from 'api/regions.api';
import entryLevelsApi from 'api/entryLevels.api';
import companiesApi from 'api/companies.api';
import sessionStore from './session.store';

configure({ enforceActions: 'observed' });

type OptionsType = Array<{
  filterPosition: number,
  id: string,
  name: string
}>;

const toOptions = (data: OptionsType, label?: string[]): Array<{ value: string, label: string }> => (
  data
    .sort((a, b) => (a.filterPosition && a.filterPosition < b.filterPosition) ? -1 : 1)
    .map(r => ({ value: r.id, label: label ? label.map(n => r[n]).join(', ') : r.name }))
);

class OptionsStore {
  @observable loading: boolean = true;
  @observable options: any = {
    studies: [],
    languages: [],
    workTypes: [],
    categories: [],
    entryLevels: [],
    branches: [],
    regions: [],
    industries: []
  };
  @observable branchesRegion: any = [];
  @observable noRegionId: number | string;

  @action.bound
  async fetchOptions(companyId: number | string) {
    const user = sessionStore.currentUser || {};

    try {
      const values = await Promise.all([
        jobsApi.languages(),
        workTypesApi.fetch(),
        studiesApi.fetch(),
        categoriesApi.fetch(),
        entryLevelsApi.fetch(),
        industriesApi.fetch(),
        regionsApi.fetch(),
        companiesApi.fetchBranches(user.companyId || companyId)
      ]);

      runInAction(() => {
        this.loading = false;
        this.options = {
          languages: toOptions(values[0].data),
          workTypes: toOptions(values[1].data),
          studies: toOptions(values[2].data),
          categories: toOptions(values[3].data),
          entryLevels: toOptions(values[4].data),
          industries: toOptions(values[5].data),
          regions: toOptions(values[6].data),
          branches: toOptions(values[7].data, ['address', 'zip', 'city'])
        };
        this.branchesRegion = Object.assign({}, ...values[7].data.map(({ id, region }) => ({ [id]: region.id })));
        this.noRegionId = values[6].data.find(i => i.isNoRegion).id;
      });
    } catch (error) {
      runInAction(() => {
        this.loading = false;
      });
    }
  }
}

export default new OptionsStore();
